import {
  IconButton,
  Typography,
  Grid,
  Box,
  CircularProgress,
  Card,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { detallesColumns } from "../detallesColumns";
import { AddCircle, Add } from "@mui/icons-material";
import { useState, useEffect } from "react";
import PedidosDetailFormFields from "./PedidosDetailsFormFields";
import { getAllDetallePedidos } from "../functions";
import { useDispatch, useSelector } from "react-redux";
import { ProductoDetail } from "./ProductoDetail";
import DeleteDetalle from "./DeleteDetalle";

const PedidoDetalle = () => {
  const [open, setOpen] = useState(false);
  const [pedidosData, setPedidosData] = useState(null);
  const [mode, setMode] = useState("POST");
  const [dataColumns, setDataColumns] = useState(null);
  const { pedidoIdSelected } = useSelector(({ pedido }) => pedido);
  const [openDetail, setOpenDetail] = useState(false);
  const [openDeleteDetalle, setOpenDeleteDetalle] = useState(false);
  const [height, setHeight] = useState(50);
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      let pedidos = await getAllDetallePedidos(pedidoIdSelected);
      setPedidosData(pedidos);
      let col = detallesColumns(
        setOpenDetail,
        setOpen,
        setMode,
        dispatch,
        setOpenDeleteDetalle,
        setHeight
      );
      setDataColumns(col);
    };
    fetchData();
  }, [open, pedidoIdSelected, openDeleteDetalle, dispatch]);

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setMode("POST");
    setOpen(true);
  };
  const handleCloseDetail = () => {
    setOpenDetail(false);
  };
  if (!pedidosData) return <>{"Recolectando datos del pedido....."}</>;

  return (
    <>
      <ProductoDetail
        pedidosData={pedidosData}
        openDetail={openDetail}
        handleCloseDetail={handleCloseDetail}
      />
      <DeleteDetalle
        setOpenDeleteDetalle={setOpenDeleteDetalle}
        openDeleteDetalle={openDeleteDetalle}
      />
      <PedidosDetailFormFields
        mode={mode}
        open={open}
        handleClose={handleClose}
        pedidosData={pedidosData}
      />
      <Box sx={{ height: 600 }}>
        <Card
          sx={{
            p: 3,
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 3,
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h4">Producto del pedido</Typography>

            <Tooltip title="Agregar Producto" placement="top">
              <IconButton
                onClick={handleOpen}
                size="medium"
                sx={{
                  backgroundColor: "#e91e63", // rosa
                  color: "white",
                  "&:hover": { backgroundColor: "#d81b60" },
                  minWidth: 80,
                  px: 1.5,
                  borderRadius: 1,
                }}
              >
                <AddCircle />
              </IconButton>
            </Tooltip>
          </Box>

          {/* Tabla */}
          <Box sx={{ flexGrow: 1 }}>
            {dataColumns ? (
              <DataGrid
                rows={pedidosData || []}
                columns={dataColumns || []}
                pageSize={10}
                rowsPerPageOptions={[10]}
                checkboxSelection
                disableSelectionOnClick
                sx={{
                  height: "100%",
                  borderRadius: 1,
                  backgroundColor: "white",
                }}
                getRowHeight={() => "auto"}
              />
            ) : (
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <CircularProgress color="primary" />
                <Typography>Cargando datos...</Typography>
              </Box>
            )}
          </Box>
        </Card>
      </Box>
    </>
  );
};
export default PedidoDetalle;
